import Dbm from "dbm";
import Website from "../../../index.js";

export default class TiledGraphic extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        let container = new PIXI.Container();
        this.item.setValue("pixiLayer", container);
        this.item.setValue("sprite", null);
        this.item.setValue("speed", 1);
    }

    setup(aTexture, aAtBottom = true, aYOffset = 0) {
        let sprite = new PIXI.TilingSprite(aTexture, Website.game.Sizes.WIDTH, aTexture.height);

        if(aAtBottom) {
            sprite.anchor.set(0, 1);
            sprite.y = Website.game.Sizes.HEIGHT;
        }

        sprite.y += aYOffset;

        this.item.sprite = sprite;
        this.item.pixiLayer.addChild(sprite);

        return this;
    }

    update(aCameraPosition, aTime, aDelta) {
        //console.log("update");

        this.item.sprite.tilePosition.x = 0.25*Math.floor(4*-1*this.item.speed*(aCameraPosition-Website.game.Sizes.CENTER_X));
    }

    hasPassed(aCameraPosition) {
        return false;
    }
}